<template>
    <div id="precheckin-custom" :class="['pre-checkin', { 'd-none': is_loading, 'kiosk-precheckin': isKioskMode }]">
        <div v-if="is_search_by_name" class="alert alert-info" role="info">
            {{ $t("checkin_by_phone.instruction_guest_name") }}
        </div>
        <div id="pcc_error_msg" v-if="error_msg" class="alert alert-danger" role="alert">
            {{ error_msg }}
        </div>
        <div id="pcc_info_msg" v-if="info_msg" class="alert alert-info" role="alert">
            {{ info_msg }}
        </div>
        <div v-if="is_search_by_name" class="choices">
            <form @submit.prevent="submitByGuestName">
                <div class="row gx-0">
                    <div class="col-md-6">
                        <div class="form-group search-suggestion-box">
                            <label>{{ $t("checkin_by_phone.label_guest_name") }}</label>
                            <input type="text" class="form-control search_field" v-model="search_guest_name" @input="searchNames" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="phone-info">
                                {{ $t("pre_checkin_amatch.checkin_date") }}
                            </label>
                            <input type="date" class="form-control" :value="checkin_date" :disabled="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-right">
                        <button class="btn btn-outline-danger mr-2" @click="is_search_by_name = false">
                            {{ $t("confirmation_modal.cancel") }}
                        </button>
                        <button type="submit" class="btn btn-primary" :disabled="!search_guest_name">
                            {{ $t("visit-information-form.confirm") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <div v-else class="choices container">
            <ul class="nav nav-pills mb-3 for_desk row" id="pills-tab" role="tablist">
               
                <!-- Name START -->
                <li class="nav-item p-1 col-12" role="button">
                    <a
                    class="nav-link text-center"
                    :class="{ active: tabActive == 'name' }"
                    @click="tabActive = 'name'"
                    v-b-toggle.accordion-name>
                        <i class="fas fa-user mr-2" />
                        <div>
                            {{ $t("checkin_by_name.label_guest_name") }}
                        </div>
                    </a>
                </li>
                <b-collapse id="accordion-name" class="w-100" accordion="my-accordion" role="tabpanel">
                    <!-- Locked out after 5 failed attempts (shared with the PCI hub by-name flow) -->
                    <div v-if="isByNameLockedOut" class="alert alert-danger m-3 m-sm-4">
                        {{ $t("checkin_by_name.error_locked_out") }}
                    </div>
                    <form v-else @submit.prevent="submitByName" class="p-3 p-sm-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("checkin_by_name.label_guest_name") }}
                                        <i class="fas fa-info-circle text-primary" v-b-tooltip.hover :title="$t('pre_checkin_bmatch.wo_name_tips')" />
                                    </label>
                                    <input v-model="guest_name" type="text" class="form-control" required :placeholder="$t('checkin_by_name.name_placeholder')" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("pre_checkin_amatch.checkin_date") }}
                                    </label>
                                    <input type="date" class="form-control" v-model="checkin_date" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-right">
                                <button type="submit" class="btn btn-primary mb-2" :disabled="!guest_name.trim()">
                                    {{ $t("visit-information-form.confirm") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </b-collapse>
                <!-- Name END --> 
                <!-- Phone START -->
                <li class="nav-item p-1 col-12" role="button">
                    <a
                    class="nav-link text-center"
                    :class="{ active: tabActive == 'phone' }"
                    @click="tabActive = 'phone'"
                    v-b-toggle.accordion-phone>
                        <i class="fas fa-phone-alt mr-2" />
                        <div>
                            {{ $t("visit-information-form.phone") }}
                        </div>
                    </a>
                </li>
                <b-collapse id="accordion-phone" class="w-100" accordion="my-accordion" role="tabpanel">
                   <form @submit.prevent="submitByPhone" class="p-3 p-sm-4">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("pre_checkin_bmatch.wo_phone_label") }}
                                        <i class="fas fa-info-circle text-primary" v-b-tooltip.hover :title="$t('pre_checkin_bmatch.wo_phone_tips')" />
                                    </label>
                                    <input
                                    type="text"
                                    class="mt-2 form-control"
                                    v-model="phone"
                                    required
                                    :placeholder="$t('pre_checkin_bmatch.wo_phone_placeholder')"
                                    @keypress="onlyNumbersAndPlus"
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("pre_checkin_amatch.checkin_date") }}
                                    </label>
                                    <input type="date" class="form-control" v-model="checkin_date" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col text-right">
                                <button type="submit" class="btn btn-primary mb-2" :disabled="!phone">
                                    {{ $t("visit-information-form.confirm") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </b-collapse>
                <!-- Phone END -->
                <!-- Email START -->
                <li class="nav-item p-1 col-12" role="button">
                    <a
                    class="nav-link text-center"
                    :class="{ active: tabActive == 'email' }"
                    @click="tabActive = 'email'"
                    v-b-toggle.accordion-email>
                        <i class="fas fa-envelope mr-2" />
                        <div>
                            {{ $t("pre_checkin_bmatch.email_label") }}
                        </div>
                    </a>
                </li>
                <b-collapse id="accordion-email" class="w-100" accordion="my-accordion" role="tabpanel">
                   <form @submit.prevent="submitByEmail" class="p-3 p-sm-4">
                        <!-- <div class="form-group">
                            <label class="email-info">
                                {{ $t("pre_checkin_bmatch.email_label") }}
                                <i class="fas fa-info-circle text-primary" v-b-tooltip.hover :title="$t('pre_checkin_bmatch.email_tips')" />
                            </label>
                            <input v-model="email" required="required" type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com" />
                        </div> -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("pre_checkin_bmatch.email_label") }}
                                        <i class="fas fa-info-circle text-primary" v-b-tooltip.hover :title="$t('pre_checkin_bmatch.wo_phone_tips')" />
                                    </label>
                                    <input v-model="email" v-half-width required="required" type="email" class="form-control" id="exampleFormControlInput1" placeholder="name@example.com"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="phone-info">
                                        {{ $t("pre_checkin_amatch.checkin_date") }}
                                    </label>
                                    <input type="date" class="form-control" v-model="checkin_date" />
                                </div>
                            </div>
                        </div>
                        <div class="text-right">
                            <button type="submit" class="btn btn-primary mb-2" :disabled="!email">
                                {{ $t("visit-information-form.confirm") }}
                            </button>
                        </div>
                    </form>
                </b-collapse>
                <!-- Email END -->
                <!-- Reservation START -->
                <li class="nav-item p-1 col-12" role="button">
                    <a
                    class="nav-link text-center"
                    :class="{ active: tabActive == 'rsv' }"
                    @click="tabActive = 'rsv'"
                    v-b-toggle.accordion-rsv>
                        <i class="fas fa-calendar-alt mr-2" />
                        <div>
                            {{ $t("visit-information-form.reservation-number") }}
                        </div>
                    </a>
                </li>
                <b-collapse id="accordion-rsv" :visible="this.$route.query.rid ? true : false" class="w-100" accordion="my-accordion" role="tabpanel">
                    <div class="row p-3 p-sm-4">
                        <div class="col-xl-5 col-sm-12 my-3 my-xl-0">
                            <div class="custom-control custom-checkbox">
                                <input v-model="rsvMode" required="required" type="radio" class="custom-control-input" id="customCheck1" name="check-in-code" value="check-in-email" data-title="Pre Check-in Email" />
                                <label class="custom-control-label" for="customCheck1">
                                    {{ $t("visit-information-form.pre-checkin-email") }}
                                </label>
                            </div>

                            <div class="custom-control custom-checkbox">
                                <input v-model="rsvMode" required="required" type="radio" class="custom-control-input" id="customCheck2" name="check-in-code" value="booking-site" data-title="Booking Site" />
                                <label class="custom-control-label" for="customCheck2">
                                    {{ $t("visit-information-form.booking-site") }}
                                </label>
                            </div>
                        </div>
                        <div class="col-xl-7 col-sm-12">
                            <form @submit.prevent="handleRsvNumSubmit(rsvMode)">
                                <div class="form-group">
                                    <label for="exampleInputEmail1" class="rsrvat-title">
                                        {{ $t(`visit-information-form.${rsvLabel}`) }}
                                    </label>
                                    <input v-model="rsvNum" id="reservation-id-input" required="required" class="form-control" type="text" :placeholder="$t('visit-information-form.type-reservation-number')" />
                                </div>
                                <div class="text-right">
                                    <button type="submit" class="btn btn-primary mb-2" :disabled="!rsvNum">
                                        {{ $t("visit-information-form.confirm") }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </b-collapse>
                <!-- Reservation END -->
                <li class="nav-item p-1 col-12" v-if="td">
                    <a class="nav-link text-center" id="pills-others-tab" href="javascript:void(0)" role="tab" aria-controls="pills-others" aria-selected="false" @click="emittedData">
                        <i class="fas fa-ellipsis-h mr-2" />
                        <div>
                            {{ $t("visit-information-form.other") }}
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/custom.scss";

.pre-checkin {
    font-family: "Poppins", sans-serif;

    .choices {
        .nav-item {
            a.nav-link {
                height: 75px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 0;
                border: 2px solid #1489ff;
                color: #1489ff;
                font-size: 14px;
            }
            a.nav-link.active {
                border: none;
                background: #1489ff;
                color: #fff !important;
            }
        }
        .form-control {
            display: block;
            width: 100%;
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            line-height: 1.5;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: none;
            border-radius: 0 !important;
            border-bottom: 1px solid #ced4da;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            &:focus {
                color: #495057;
                background-color: #fff;
                border-color: unset;
                outline: 0;
                box-shadow: none;
            }
            &::placeholder {
                color: #cccccc;
                font-size: 12px;
            }
            /* visible disabled styling */
            &[disabled],
            &.disabled,
            input[disabled] {
                background-color: #f4f6f8;
                color: #495057;
                opacity: 1; /* keep full opacity so text is readable */
                cursor: not-allowed;
                border-bottom: 1px dashed #bfc9d3;
            }
        }
        .vue-tel-input {
            border: none;
            border-bottom: 1px solid #dee2e6 !important;
            &:focus-within {
                box-shadow: unset;
            }
        }
        label {
            font-size: 14px;
            color: #4d4d4d;
        }
        .btn {
            border: none;
            border-radius: 20px;
            padding: 8px 50px;
            font-size: 14px;
            transition: all 0.5s ease-in-out;
        }
        .btn-primary {
            background: #1aa8de !important;
            border: 1px solid #1aa8de !important;
        }
        .btn-outline-danger {
            border: 1px solid #dc3545 !important;
        }
    }
}

#precheckin-custom {
    $btn-color: #636363;

    .img-fluid {
        width: 300px;
        @extend .img-fluid;
    }

    .img-fluid-s {
        width: 200px;
        @extend .img-fluid;
    }

    .btn-custom {
        color: $btn-color;
    }

    .form-control {
        @extend .m-0, .mt-1;
    }

    .btn-top {
        @extend .btn-custom;
        font-size: calc(30px + (30 - 10) * ((100vw - 300px) / (1600 - 300)));
    }

    .btn-sub {
        @extend .btn-custom;
        font-size: calc(20px + (20 - 10) * ((100vw - 300px) / (1600 - 300)));
    }

    .btn-header {
        border: 1px solid #517ac4;
        background: transparent;
    }

    .accordion > .card,
    .card-header {
        border: none;
        background: transparent;
    }
    .btn:not(.collapsed) > .when-closed,
    .btn.collapsed > .when-open {
        display: none;
    }

    .highlight:not(.collapsed) {
        background-color: blue;
    }
    .highlight.collapsed {
        background-color: #1489ff;
    }

    .tip {
        color: #65abff;
        font-size: 20px;
    }
}

/* Search Suggestion Box */
.search-suggestion-box {
  position: relative;
  .suggestion-list {
    display: none;
    position: absolute;
    top: 71px;
    left: 0px;
    background-color: white;
    width: 100%;
    border: 1px solid #ced4da;
    padding-left: 0px;
    li.suggestion {
      display: block;
      width: 100%;
      padding: 5px;
      cursor: pointer;
      opacity: 0.8;
      &:hover {
        background-color: whitesmoke;
        opacity: 1;
      }
    }
  }
}
.search_field:focus {
  &~ul.suggestion-list {
    display: block;
  }
}

/* Guest Hub (kiosk): reached from the home screen's "Start Pre Check-in"
   button, this landing page is a tablet screen pressed with a finger rather
   than a phone page read at arm's length. The method buttons, panel fields and
   confirm buttons grow to the same sizes the kiosk check-in hub uses
   (checkin_kiosk_hub_component.vue) so the whole kiosk flow reads alike. */
.pre-checkin.kiosk-precheckin {
    touch-action: manipulation;

    .choices {
        .nav-item {
            a.nav-link {
                height: auto;
                min-height: 72px;
                border-radius: 8px;
                font-size: clamp(18px, 2.6vw, 26px);
                font-weight: 600;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
                touch-action: manipulation;
                user-select: none;
                -webkit-user-select: none;

                i {
                    font-size: 1.2em;
                }
            }
        }

        label {
            font-size: clamp(14px, 2vw, 18px);
            font-weight: 600;
        }

        .form-control {
            min-height: 48px;
            font-size: clamp(16px, 2.2vw, 20px);

            &::placeholder {
                font-size: clamp(14px, 2vw, 18px);
            }
        }

        /* vue-tel-input renders its own input, so the size has to be pushed
           past the scoped boundary to reach it. */
        .vue-tel-input {
            ::v-deep .vti__input,
            ::v-deep .vti__selection {
                min-height: 48px;
                font-size: clamp(16px, 2.2vw, 20px);
            }
        }

        .btn {
            min-width: 156px;
            min-height: 48px;
            border-radius: 24px;
            padding: 8px 40px;
            font-size: clamp(16px, 2.2vw, 20px);
            font-weight: 600;
            touch-action: manipulation;
        }
    }

    /* Bootstrap's custom radio draws its dot with pseudo-elements at a fixed
       1rem, so the box has to be grown (and re-offset) along with the text. */
    .custom-control {
        padding-left: 2.5rem;
        margin-bottom: 12px;
        min-height: 2rem;
    }

    .custom-control-label {
        font-size: clamp(16px, 2.2vw, 20px);
        line-height: 1.6;
        cursor: pointer;

        &::before,
        &::after {
            width: 1.5rem;
            height: 1.5rem;
            left: -2.5rem;
            top: 0.1rem;
        }
    }

    .alert {
        font-size: clamp(15px, 2vw, 19px);
    }
}

</style>

<script>
import { mapActions } from "vuex/dist/vuex.common.js";
import { booking_status } from "./../../../utils/mockup";
import checkinByNameMixin, { BY_NAME_RESULT, BY_NAME_FEEDBACK } from "./../../../utils/checkinByNameMixin";
// guest state store
import { mapState } from "vuex";
import moment from "moment-timezone";
import { isKioskRoute } from "./../kiosk/kiosk_config";
import { onlyNumbersAndPlus } from "../../../utils/helpers";

export default {
    mixins: [checkinByNameMixin],
    props: ["booking_details", "facility", "is_localized", "mr_visible"],

    data() {
        return {
            reservation_no: "",
            reservation_no_query: "",
            ota_number: "",
            phone: "",
            email: "",
            checkin_date: "",
            search_guest_name: "",
            search_name_matches: [],
            booking_details_fetched: [],
            phoneSettings: {
                number: {
                    input: "",
                },
                possible: false,
            },
            error_msg: "",
            info_msg: "",
            booking_error_msg: false,
            duplicate_error: {
                status: false,
                mode: "",
            },
            td: false,
            isTouchdown: false,
            rsvMode: "check-in-email",
            rsvNum: "",
            rsvLabel: "pre-checkin-email-reservation-number",
            tabActive: null,
            is_loading: false,
            is_search_by_name: false,
        };
    },

    computed: {
        // Reached through the Guest Hub (kiosk) "Start Pre Check-in" button,
        // which lands here with ?kiosk=true. Only used for tablet sizing.
        isKioskMode() {
            return isKioskRoute(this.$route);
        },
    },

    watch: {
        rsvMode(val) {
            if (val == "check-in-email") {
                this.rsvLabel = "pre-checkin-email-reservation-number";
            }
            if (val == "booking-site") {
                this.rsvLabel = "booking-site-reservation-number";
            }
        },
    },

    mounted() {
        if (this.$route.query.rid) {
            this.is_loading = true;
            this.$emit('update-is_loading', true);
            this.rsvNum = this.$route.query.rid;
            this.tabActive = 'rsv'
            document.getElementById("reservation-id-input").scrollIntoView({ behavior: "smooth", block: "center" });
            this.handleRsvNumSubmit(this.rsvMode); // auto confirm
        }

        if (this.$route.query.ref && this.$route.query.ref == "td") {
            this.td = true;
         }
         // "tdf" = Touch Down Without Others: same touchdown context as "td", just without the
         // walk-in/"Others" tab, so date/time restriction must still apply to it.
         if (this.$route.query.ref && (this.$route.query.ref == "td" || this.$route.query.ref == "tdf")) {
            this.isTouchdown = true;
         }
         let now = (new Date()).toISOString().replace(/T\d{2}:\d{2}:\d{2}\.\d{3}Z$/, '');
         this.checkin_date = now;
    },
    methods: {
        ...mapActions("memorizedInputs", ["saveCheckinFormType"]),
            // map actions
        ...mapActions("guest", [
            "saveNumberOfGuest",
            "setBookingPass",
            "savePmsCode",
            "saveUserRemarks",
            "saveRsvNo",
            "saveBookingPlanCode",
            "saveRoomNo"
        ]),
        onlyNumbersAndPlus,
        submitReservation() {
            const search = this.reservation_no;
            this.getBooking({ mode: "reservation", search });
        },

        submitByPhone() {
            let search = this.phone;

            this.getBooking({ mode: "phone", search, checkin_date: this.checkin_date });
        },

        submitByOta() {
            const search = this.ota_number;

            this.getBooking({ mode: "ota", search });
        },

        submitByEmail() {
            const search = this.email;

            this.getBooking({ mode: "email", search, checkin_date: this.checkin_date });
        },

        async submitByName() {
            // API call to MR settings
            await this.getMulipleRoomSetting();

            const { result, booking } = await this.searchBookingByName({
                facility_id: this.facility.id,
                checkin_date: this.checkin_date,
                // This is the pre-check-in form itself, so a pre_check_in booking is already done here.
                preCheckinIsCompleted: true,
            });

            if (result !== BY_NAME_RESULT.found) {
                // Locked out — the tab swaps to the locked out message
                if (result === BY_NAME_RESULT.locked_out) return;

                const { type, key } = BY_NAME_FEEDBACK[result];
                if (type === "info") return this.infoDisplay(this.$t(key));
                return this.errorDisplay2(this.$t(key));
            }

            this.finalizeSelectedBooking({ data: [booking], total: 1 });
        },

        submitByGuestName(e) {
            const checkedOutStatusIds = [3, 10, 11, 15, 16, 17];
            const guestName = this.search_guest_name;
            const normalizeSearchableNameString = (str) => str.replace(/\s/g, '').toLowerCase();
            const matchByExactName = this.booking_details_fetched.data.filter(
                o => normalizeSearchableNameString(o.parsed.full_name) == normalizeSearchableNameString(guestName)
            );

            if (matchByExactName.length < 1) {
                // Stop if guest name input is a missmatch from cached list.
                let errorMsg = this.$t('checkin_by_phone.error_no_reservation');
                this.errorDisplay2(errorMsg);
            } else if (matchByExactName.length > 1) {
                // Stop if guest name input has multiple match found.
                let errorMsg = this.$t('checkin_by_phone.error_multiple_reservation');
                this.errorDisplay2(errorMsg);
            } else if (matchByExactName[0].booking_status_id == 2) {
                // Stop if guest has already checked in (status 2 = checked in)
                let errorMsg = this.$t('checkin_by_phone.info_already_checkedin');
                this.errorDisplay2(errorMsg);
            } else if (checkedOutStatusIds.includes(matchByExactName[0].booking_status_id)) {
                // Stop if guest has already checked out (see checkedOutStatusIds above)
                let errorMsg = this.$t('checkin_by_phone.error_already_checkedout');
                this.errorDisplay2(errorMsg);
            } else {
                const bookingDetails = { data: matchByExactName, total: 1 };
                this.finalizeSelectedBooking(bookingDetails);
            }
        },

        searchNames(e) {
            const guestName = this.search_guest_name;

            const searchNameMatches = this.booking_details_fetched.data.filter(function(o) {
                var re = new RegExp(guestName);
                return o.parsed.full_name.search(re) > -1;
            });

            this.search_name_matches = searchNameMatches;
        },

        async getBooking(obj) {
            // API call to MR settings
            await this.getMulipleRoomSetting();

            let searchPayload = {
                    facility_id: this.facility.id,
                    mode: obj.mode,
                    search: obj.search,
                };
            if ('checkin_date' in obj) searchPayload.checkin_date = obj.checkin_date;

            let booking_details = await this.$lionheart
                .post("/facility-booking/list", searchPayload)
                .then((r) => this.catcher(r.data, "data", (r) => r))
                .catch((e) => this.catcher(e));

            if (booking_details.error.has_error) this.errorDisplay(booking_details);

            booking_details.data = booking_details.data.filter((item) => {
                return item.booking_status_id == booking_status.reserved;
            });
            booking_details.total = booking_details.data.length;

            if (booking_details.total > 1 && !this.mr_visible) {
                this.is_loading = false;
                this.$emit('update-is_loading', false);

               if (obj.mode == 'phone' || obj.mode == 'email') {
                  this.booking_details_fetched = booking_details;
                  this.is_search_by_name = true;
                  return;
               }

                this.errorDisplay2(this.$t("pre_checkin_bmatch.duplicate_"+obj.mode));
                this.duplicate_error.mode = obj.mode;
                return (this.duplicate_error.status = true);
            }

            if (booking_details.total == 0) {
                this.is_loading = false;
                this.$emit('update-is_loading', false);
                this.errorDisplay2(this.$t("pre_checkin_bmatch.not_found_msg"));
                return (this.booking_error_msg = true);
            }

            // success result
            if (booking_details.total > 0) {
                this.finalizeSelectedBooking(booking_details);
            }
        },

        async finalizeSelectedBooking(booking_details) {
            if (booking_details.data[0].booking_status_id != booking_status.reserved) {
                this.is_loading = false;
                this.$emit('update-is_loading', false);
                this.errorDisplay2(this.$t("pre_checkin_bmatch.not_found_msg"));
                return (this.booking_error_msg = true);
            }

            // Touchdown-only (covers both "td" and "tdf"/no-others): block guests whose reservation's
            // own checkin_date (or the current time) falls outside the facility's configured check-in
            // operation settings. Genuine Pre-Checkin (isTouchdown=false) is intentionally exempt —
            // guests are meant to complete that in advance of arrival.
            if (this.isTouchdown) {
                const restriction = await this.$lionheart
                    .post("/checkin/touchdown-restriction-check", {
                        facility_id: this.facility.id,
                        pms_reservation_no: booking_details.data[0].pms_reservation_no,
                        pass: booking_details.data[0].pass,
                    })
                    .then((r) => r.data)
                    .catch(() => ({ isCheckinAvailable: true }));

                if (restriction.isCheckinAvailable === false) {
                    this.is_loading = false;
                    this.$emit('update-is_loading', false);
                    const message = restriction.reason === 'date'
                        ? this.$t('visit-information-form.checkin_date_restricted_msg')
                        : this.$t('visit-information-form.checkin_restricted_msg', {
                            from: moment(restriction.from, "HH:mm").format("h:mm A"),
                            to: moment(restriction.to, "HH:mm").format("h:mm A"),
                        });
                    this.errorDisplay2(message);
                    return (this.booking_error_msg = true);
                }
            }

            // save the pass for meal reservation search
            this.setBookingPass(this.booking_details?.data[0]?.pass)
            // save the number of guest
            this.saveNumberOfGuest(this.booking_details?.data[0]?.parsed?.total_number_of_guests)
            // save the pms code
            this.savePmsCode(this.booking_details?.data[0]?.pms_code);
            // save user remarks
            this.saveUserRemarks(this.booking_details?.data[0]?.parsed?.user_remarks)
            // save rsvNo
            this.saveRsvNo(this.booking_details?.data[0]?.pms_reservation_no)
            // save booking plan code
            this.saveBookingPlanCode(this.booking_details?.data[0]?.parsed?.booking_plan_code);
            // save the roomno
            this.saveRoomNo(this.booking_details?.data[0]?.parsed?.room_number);
    

            this.$emit("update-booking", booking_details);
            this.$emit("update-next", this.is_localized ? "localized-filters" : "select-option");
            if (!this.is_localized) this.$emit("update-multiple-data", true);
            this.$emit("update-rsv-no", this.reservation_no);
            let reservation_no = booking_details.data[0].pms_reservation_no ?? null;
            this.$emit("update-rsv-no-query", reservation_no);
            this.is_loading = false;
            this.$emit('update-is_loading', false);
        },

        async getMulipleRoomSetting() {
            const mrSetting = await this.$lionheart
                .post("/facility-setting/list", {
                    facility_id: this.facility.id,
                    name: "mr_setting",
                    paginate: false,
                })
                .then((r) => this.catcher(r.data, "data", (r) => r))
                .catch((e) => this.catcher(e));

            if (mrSetting.error.has_error) {
                this.errorDisplay(mrSetting);
                throw "Error on MR switch fetch";
            }

            if (mrSetting.total > 0) {
                this.$emit("update-mr_visible", mrSetting.data[0].value.visibility);
            }
        },

        phoneInput(str, obj) {
            this.phoneSettings = obj;
        },

        phoneCountryChange(obj) {
            if (this.phoneSettings.number.input != "") this.phone = "";
        },

        errorDisplay(d) {
            this.error_msg = d.error.msg;
            setTimeout(() => window.scrollTo(0, $("#pcc_error_msg").position().top - 10), 300);
            setTimeout(() => this.error_msg = "", 4000);
            return;
        },

        errorDisplay2(error_msg) {
            this.error_msg = error_msg;
            setTimeout(() => window.scrollTo(0, $("#pcc_error_msg").position().top - 10), 300);
            setTimeout(() => this.error_msg = "", 4000);
            return;
        },

        infoDisplay(info_msg) {
            this.info_msg = info_msg;
            setTimeout(() => window.scrollTo(0, $("#pcc_info_msg").position().top - 10), 300);
            setTimeout(() => this.info_msg = "", 4000);
            return;
        },

        checkinErrorDisplay(ref) {
            setTimeout(() => window.scrollTo(0, $(`${ref}`).position().top - 10), 300);

            setTimeout(() => (this.booking_error_msg = false), 3000);
        },
        checkinErrorDuplicateDisplay(ref) {
            setTimeout(() => window.scrollTo(0, $(`${ref}`).position().top - 10), 300);

            setTimeout(() => (this.duplicate_error.status = false), 5000);
        },
        imageLoader(name) {
            try {
                return require(`@/modules/checkin-facility/assets/img/${this.$i18n.locale}/${name}`);
            } catch (e) {
                return require(`@/modules/checkin-facility/assets/img/en/${name}`);
            }
        },

        handleRsvNumSubmit(rsvMode) {
            if (rsvMode == "check-in-email") {
                this.reservation_no = this.rsvNum;
                this.reservation_no_query = this.rsvNum;
                this.saveCheckinFormType("rsv")
                this.submitReservation();
            }
            if (rsvMode == "booking-site") {
                this.ota_number = this.rsvNum;
                this.reservation_no_query = this.rsvNum;
                this.saveCheckinFormType("rsv")
                this.submitByOta();

                // Emit to parent
                // this.$emit("updateOtaNumber", this.ota_number);
            }
        },
         //emit form type click
        emittedData() {
            this.$emit('update-next', this.is_localized ? 'localized-filters' : 'checkin-form')
            this.saveCheckinFormType("walk-in")
        },
    },
};
</script>
